"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconList = ['menu', 'close', 'chevron-left', 'chevron-right', 'chevron-down', 'chevron-up', 'arrow-right', 'bang'];
var iconSizes = ['tiny', 'small', 'large', 'huge'];
var colors = ['red', 'green'];

var MorphIcon = function MorphIcon(_ref) {
  var type = _ref.type,
      size = _ref.size,
      color = _ref.color,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "size", "color", "className"]);

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, 'icon__morph', "-".concat(type), "-".concat(size), color)
  }, props), _react.default.createElement("div", {
    className: "icon__morph-block -m1"
  }), _react.default.createElement("div", {
    className: "icon__morph-block -m2"
  }), _react.default.createElement("div", {
    className: "icon__morph-block -m3"
  }));
};

MorphIcon.displayName = 'MorphIcon';
MorphIcon.propTypes = {
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(iconList).isRequired,
  size: _propTypes.default.oneOf(iconSizes),
  color: _propTypes.default.oneOf(colors)
};
var _default = MorphIcon;
exports.default = _default;